module.exports = __webpack_public_path__ + "static/img/w9.a396ffe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/mobile/w9.jpg
// module id = p30P
// module chunks = 1